import {QueryGateway} from "./query-gateway";
import {HandlerOptions} from "./handler";

export function HandleQuery(name?: string, options?: HandlerOptions): MethodDecorator {
  return (target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor): PropertyDescriptor => {
    QueryGateway.registerHandlerInvoker(target.constructor.name, name || String(propertyKey), descriptor.value, options);
    return descriptor;
  }
}
